import { nomeBaseFileMandato } from './utils';

// Nome dei file della relazione: Relazione_<Nr. Mandato>[_<n>].<ext> (id del mandato se il numero
// manca), senza nomi di clienti o soggetti. <n> è la posizione del soggetto nel mandato, come per
// il PDF archiviato dal backend.

function nrMandato(pratica: any): string | null {
    try {
        const raw = pratica?.datiAggiuntiviJson;
        const dati = typeof raw === 'string' ? JSON.parse(raw) : (raw || {});
        const rif = dati?.rif_numero_pratica;
        if (rif != null && String(rif).trim()) return String(rif).trim();
    } catch {
        // dati non leggibili: si prova dal nome
    }
    const name = String(pratica?.name || '');
    if (!name.startsWith('Mandato ')) return null;
    const nr = name.slice('Mandato '.length).split(' - ')[0].trim();
    return nr || null;
}

function soggettoIndex(pratica: any, soggetto?: string | null): string | null {
    const target = (soggetto || '').trim().toLowerCase();
    if (!target) return null;
    try {
        const raw = pratica?.datiAggiuntiviJson;
        const dati = typeof raw === 'string' ? JSON.parse(raw) : (raw || {});
        const lista: any[] = Array.isArray(dati?.soggetti) ? dati.soggetti : [];
        const i = lista.findIndex(s => String(s?.nome || '').trim().toLowerCase() === target);
        if (i >= 0) return String(i + 1);
        const legacy = String(dati?.soggetto_nome || dati?.soggetto_denominazione || '').trim().toLowerCase();
        if (legacy && legacy === target) return '1';
    } catch {
        // dati non leggibili: nessun suffisso
    }
    return null;
}

export function relazioneFileName(praticaId: string | number | undefined, pratica: any,
                                  soggetto: string | null | undefined, ext: 'pdf' | 'docx'): string {
    const idx = soggettoIndex(pratica, soggetto);
    const id = praticaId != null && String(praticaId) !== '' ? Number(praticaId) : null;
    const base = nomeBaseFileMandato(nrMandato(pratica), Number.isFinite(id as number) ? id : null);
    return `Relazione_${base}${idx ? `_${idx}` : ''}.${ext}`;
}
